import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Landing } from "@modules/landings/types";
import { LandingFormValues } from "@modules/landings/validations";
import { editLandingService } from "./service";
import { UseEditLandingMutationOptions } from "./types";

export function useEditLandingMutation(
  id: string,
  options?: UseEditLandingMutationOptions
) {
  const { open } = useNotification();
  const translate = useTranslate();

  return useMutation<Landing, ApiError, Partial<LandingFormValues>>({
    mutationFn: (data) => editLandingService(id, data),
    onSuccess: () => {
      open?.({
        type: "success",
        message: translate("v1/landing_admin.success.edit"),
      });
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
